// @angular
import { Injector } from "@angular/core";
import { LOCATION_INITIALIZED } from "@angular/common";
import { Observable, of } from "rxjs";

// Translator
import { TranslateLoader, TranslateService } from "@ngx-translate/core";
import { LANGUAGE } from "./services/language/LanguageController.service";

// Statically imports the JSON locale files
import localeEs from "../i18n/es.json";
import localeEn from "../i18n/en.json";
import localeIt from "../i18n/it.json";
import localeFr from "../i18n/fr.json";
import localeCat from "../i18n/es-ca.json";
import localeEl from "../i18n/el.json";
import localePt from "../i18n/pt.json";

// Maps the available languages
const languages: { [key: string]: any } = {
  es: localeEs,
  en: localeEn,
  it: localeIt,
  fr: localeFr,
  "es-ca": localeCat,
  el: localeEl,
  pt: localePt
};

// Imports for date formatting
import es from "@angular/common/locales/es";
import en from "@angular/common/locales/en";
import it from "@angular/common/locales/it";
import fr from "@angular/common/locales/fr";
import cat from "@angular/common/locales/ca-ES-valencia";
import el from "@angular/common/locales/el";
import pt from "@angular/common/locales/pt-PT";
import { registerLocaleData } from "@angular/common";
registerLocaleData(es);
registerLocaleData(en);
registerLocaleData(fr);
registerLocaleData(it);
registerLocaleData(cat);
registerLocaleData(el);
registerLocaleData(pt);

/****************************************************************************************************/
// Translation loader and app initializer
/****************************************************************************************************/

/** Loads statically bundled translations without making HTTP requests. */
export class BundledTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<any> {
    // Returns the bundled JSON immediately, without HTTP requests
    return of(languages[lang] || languages['en']);
  }
}

/** Initializes ngx-translate after location startup, using a supported stored or browser language. */
export function appInitializerFactory(translate: TranslateService, injector: Injector) {
  return () =>
    new Promise<any>((resolve: any) => {
      const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
      const storedLang = localStorage.getItem("lang");

      locationInitialized.then(() => {
        translate.addLangs([
          LANGUAGE.ESPANOL,
          LANGUAGE.CATALAN,
          LANGUAGE.INGLES,
          LANGUAGE.FRANCES,
          LANGUAGE.ITALIANO,
          LANGUAGE.GRIEGO,
          LANGUAGE.PORTUGUES
        ]);
        let browserLang = translate.getBrowserLang();
        let lang: string;

        if (browserLang.match(/en|es|it|fr|es-ca|el|pt/)) {
          lang = browserLang.toLowerCase();
        } else {
          lang = LANGUAGE.INGLES;
        }

        if (translate.getLangs().includes(storedLang || lang)) {
          translate.use(storedLang || lang).subscribe({
            error: e => console.error(e),
            complete: () => resolve(null)
          });
        } else {
          translate.use(LANGUAGE.INGLES).subscribe({
            error: e => console.error(e),
            complete: () => resolve(null)
          });
        }
      });
    });
}
